/** Max length aligned with backend `banner_image_url` VARCHAR(500). */
const BANNER_MAX_LENGTH = 500;

/** Only allow real remote URLs for banner / persisted fields (never blob: or data:). */
export function safeHttpUrl(value: unknown): string | undefined {
  if (typeof value !== 'string') return undefined;
  const t = value.trim();
  if (!t || t.length > BANNER_MAX_LENGTH) return undefined;
  if (!/^https?:\/\//i.test(t)) return undefined;
  return t;
}

function isUnsafeClientMediaUrl(value: unknown): boolean {
  if (typeof value !== 'string') return false;
  const t = value.trim().toLowerCase();
  return t.startsWith('blob:') || t.startsWith('data:');
}

/**
 * extraData for admin create/update: gallery is stored via event_media endpoints.
 * Omits duplicate top-level fields and strips blob/data URLs from any values.
 */
export function buildAdminEventExtraData(
  data: Record<string, unknown>
): Record<string, unknown> {
  const skipKeys = new Set([
    'id',
    'title',
    'description',
    'category',
    'venueId',
    'date',
    'time',
    'bookingStartDate',
    'bookingEndDate',
    'image',
    'organizerName',
    'organizerContact',
    'termsAndConditions',
    'images',
    'videos',
    'tiers',
    'slug',
    'status',
    'eventDate',
    'bannerImageUrl',
    'extraData',
  ]);
  const out: Record<string, unknown> = {};
  for (const [k, v] of Object.entries(data)) {
    if (skipKeys.has(k)) continue;
    if (typeof v === 'string' && isUnsafeClientMediaUrl(v)) continue;
    if (Array.isArray(v)) {
      const filtered = v.filter(
        (item) => !(typeof item === 'string' && isUnsafeClientMediaUrl(item))
      );
      if (filtered.length > 0) out[k] = filtered;
      continue;
    }
    out[k] = v;
  }
  const cover = safeHttpUrl(data.image);
  if (cover) out.image = cover;
  return out;
}
